<template>
  <div class="not-found">
    <h1 class="normal" id="page-title-for-sr">
      <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
      <span aria-live="assertive" role="status" v-html="$t('confirmation.notFound.header')"></span>
    </h1>
    <p v-html="$t('confirmation.notFound.description')"></p><p v-html="$t('confirmation.notFound.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationNotFound'
}
</script>
